/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */

// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import * as GenericChannelIds from 'conversations-thread-data/generic-channels/public/constants';
import { getId, getEntryUrlContext, getFormContext, getChatflowContext, getConnectedObjectSourceId, getConnectedAccountContext, getForwardedEmailContext, getCustomContext } from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import DashedLabel from 'conversations-inbox-message-history/atoms/DashedLabel';
import ChatflowContextUpdateContainer from './ChatflowContextUpdateContainer';
import FormContextUpdateMessageContainer from './FormContextUpdateMessageContainer';
import ConnectedAccountContextUpdate from './ConnectedAccountContextUpdate';
import ForwardedEmailContextUpdate from './ForwardedEmailContextUpdate';
import EntryUrlContextUpdate from './EntryUrlContextUpdate';
import CustomContextUpdate from './CustomContextUpdate';
import { isFacebookMessengerGenericChannel } from '../../operators/isFacebookMessengerGenericChannel';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  inboxId: PropTypes.number.isRequired,
  message: RecordPropType('ContextUpdateMessage').isRequired,
  genericChannelId: PropTypes.oneOf(Object.values(GenericChannelIds))
};
class ContextUpdateMessage extends PureComponent {
  renderEntryUrl() {
    return /*#__PURE__*/_jsx(EntryUrlContextUpdate, {
      message: this.props.message
    });
  }
  renderConnectedAccount() {
    const {
      inboxId,
      message
    } = this.props;
    return /*#__PURE__*/_jsx(ConnectedAccountContextUpdate, {
      inboxId: inboxId,
      message: message
    });
  }
  renderForwardedEmail() {
    const {
      inboxId,
      message
    } = this.props;
    return /*#__PURE__*/_jsx(ForwardedEmailContextUpdate, {
      inboxId: inboxId,
      message: message
    });
  }
  renderCustomContextUpdate() {
    const {
      message
    } = this.props;
    return /*#__PURE__*/_jsx(CustomContextUpdate, {
      message: message
    });
  }
  renderChatFlow() {
    const {
      genericChannelId,
      message
    } = this.props;
    const chatflowId = getId(getChatflowContext(message));
    const isFacebookChatflow = isFacebookMessengerGenericChannel(genericChannelId);
    return /*#__PURE__*/_jsx(ChatflowContextUpdateContainer, {
      chatflowId: chatflowId,
      message: message,
      isFacebookChatflow: isFacebookChatflow
    });
  }
  renderFormMessage() {
    const {
      inboxId,
      message
    } = this.props;
    const formId = getConnectedObjectSourceId(getFormContext(message));
    return /*#__PURE__*/_jsx(FormContextUpdateMessageContainer, {
      formId: formId,
      inboxId: inboxId,
      message: message
    });
  }
  renderMessageType() {
    const {
      message
    } = this.props;
    const entryUrl = getEntryUrlContext(message);
    const form = getFormContext(message);
    const chatflow = getChatflowContext(message);
    const connectedAccount = getConnectedAccountContext(message);
    const forwardedEmail = getForwardedEmailContext(message);
    const custom = getCustomContext(message);
    if (form) {
      return this.renderFormMessage();
    }
    if (chatflow) {
      return this.renderChatFlow();
    }
    if (forwardedEmail) {
      return this.renderForwardedEmail();
    }
    if (connectedAccount) {
      return this.renderConnectedAccount();
    }
    if (entryUrl) {
      return this.renderEntryUrl();
    }
    if (custom) {
      return this.renderCustomContextUpdate();
    }
    return null;
  }
  render() {
    const messageContent = this.renderMessageType();
    return messageContent && /*#__PURE__*/_jsx(DashedLabel, {
      transparent: true,
      children: messageContent
    });
  }
}
ContextUpdateMessage.propTypes = propTypes;
export default ContextUpdateMessage;